import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Typography } from '../styled'
import theme from '../../constants/theme'
import Trash from '../../assets/svgs/trash'
import { Card, CardHead, NumberBadge, RemoveButton, Divider } from './styled'

function ReferenceCard({ index, canRemove, onRemove, children }) {
  const { t } = useTranslation()
  return (
    <Card>
      <CardHead>
        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
          <NumberBadge>{index + 1}</NumberBadge>
          <Typography size="15px" bold color={theme.gray100}>
            {t('reference.title', { index: index + 1 })}
          </Typography>
        </div>
        {canRemove && (
          <RemoveButton type="button" onClick={onRemove}>
            <Trash width="15" height="15" />
            {t('reference.remove')}
          </RemoveButton>
        )}
      </CardHead>
      <Divider />
      {children}
    </Card>
  )
}

ReferenceCard.propTypes = {
  index: PropTypes.number.isRequired,
  canRemove: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default ReferenceCard
